class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.suggestedSearch = this.querySelector('#suggested-search-results');
    this.redirectsPairs = {
      'return' :'https://help.winkscrubs.com/en-US/articles/returns_&_exchanges-61206',
      'returns' :'https://help.winkscrubs.com/en-US/articles/returns_&_exchanges-61206',
      'shipping' : 'https://help.winkscrubs.com/en-US/articles/shipping-61211 '
    };
    this.exposed = this.dataset.exposedPs;
  }

  connectedCallback() {
    this.addDeligatedEventListener();
  }

  addDeligatedEventListener() {
    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.input.addEventListener('keydown', (e) => {
      const searchTerm = this.input.value.trim();
      if (e.key === 'Enter') {
        for (const term in this.redirectsPairs) {
          if (searchTerm == term) {
            e.preventDefault()
            window.location.href = this.redirectsPairs[term];
          }
        }
      }
    });
  }
  

  onChange() {
    const searchTerm = this.input.value.trim();
    this.getSearchResults(searchTerm);
  }

  updateSearchResults(results, searchTerm) {
    this.predictiveSearchResults.innerHTML = `
      <div id="predictive-search-results" class="fixed lg:w-[600px] lg:-mt-2 bg-primaryLight rounded-lg p-4 left-4 right-4 ${this.exposed ? 'top-36 exposed-results' : 'top-24'} lg:right-auto lg:left-auto lg:top-auto">
        <ul role="listbox" aria-label="predictive search products" class="flex flex-col">
          ${results.map((product) => product && `
            <li role="option" class="py-2 border-b border-primaryHalfDark capitalize">
              <a href="${product.url}" class="flex items-center gap-6 no-underline">
                <div class="w-16">
                ${product.image ? `
                  <img loading="lazy" height="1200" width="1200" sizes="(min-width:768px) 600px, (min-width:1600px) 800px, (min-width:2000px) 1200px" class="mix-blend-multiply w-80" src=${product.image}>
                ` : `
                  <div class="bg-secondaryDark aspect-[4/5]">
                    <svg class="object-center h-full w-full object-cover mix-blend-multiply" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"></path><path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z"></path><path d="M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z"></path></svg>
                  </div>
                `}
                </div>
                <div class="flex flex-col gap-3">
                  <span class="text-primaryDark text-sm font-condensed">
                    ${product.title.toLowerCase().split(searchTerm).join('<span class="text-primaryDark text-sm font-condensed">'+ searchTerm +'</span>')}
                  </span>
                  <div class="flex gap-2"> 
                    ${product.compare_at_price_max > product.price ? `<span class="text-primaryDark text-sm line-through opacity-60">${product.compare_at_price_max.endsWith('.00') ? product.compare_at_price_max.slice(0, -3) : product.compare_at_price_max}</span>` : `` }
                    <span class="${product.compare_at_price_max > product.price ? `text-crimsonRed -order-1` : `text-primaryDark`} text-sm">$${product.price.endsWith('.00') ? product.price.slice(0, -3) : product.price}</span>
                  </div>
                </div>
              </a>
            </li>
            `).join('')}
        </ul>
        <div class="flex pt-8 pb-4 justify-center">
          <a href="/search?q=${searchTerm}" class="text-sm text-primaryDark font-semibold">View All Results</a>  
        </div>
      </div>`
  }

  async getSearchResults(searchTerm) {
    await fetch(`${window.Shopify.routes.root}search/suggest.json?q=${searchTerm}&resources[limit]=5&resources[type]=product&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,tag,variants.title,variants.sku`)
    .then((response) => response.json())
      .then((suggestions) => {
        if (suggestions.resources.results.products.length == 0 ) {
          this.predictiveSearchResults.style.display = 'none';
          this.suggestedSearch.querySelector('[data-search-title]').innerHTML = searchTerm
          this.suggestedSearch.style.display = 'block';
        } else {
          this.predictiveSearchResults.style.display = 'block';
          this.suggestedSearch.style.display = 'none';
          const productSuggestions = suggestions?.resources?.results?.products.filter(({ tags }) => !tags.find(x => x === 'base_product') && !tags.find(x => x === 'hide_product'));
          this.allTitles = `${productSuggestions.map(({ title }) => title).join(',').split(',').filter(x => x.length > 1).map((x) => x).join(',')}`;
          this.updateSearchResults(productSuggestions, searchTerm);
        }
      }
    )
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    document.querySelector('[data-action=close-search]').click()
  }
}

customElements.define('predictive-search', PredictiveSearch);
